// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__2WKt9","input":"Switch_input__3lHUJ","inner":"Switch_inner__1TPp1","box":"Switch_box__13Z4d"};